import React from "react"

import TrafficLightWidget from "../Common/TrafficLightWidget"
import arrow from "../../images/lamp/remark_arrow.png"

import * as styles from "./Styles/Lamp.module.scss"
import classNames from "classnames/bind"
const cn = classNames.bind(styles)

const LampInner = (props) => {
  return (
    <React.Fragment>
      <TrafficLightWidget currentColor={props.color} width={100} />
      <span className={cn("lampMessage", `lampMessage--${props.color}`)}>
        {props.lamp.message}
      </span>
      {props.lamp.available && (
        <span className={styles.created}>{props.lamp.description}</span>
      )}
    </React.Fragment>
  )
}

const Lamp = (props) => {
  const lamp = props.lamp

  return (
    <div className={styles.lampContainer}>
      <h2 className={styles.header}>混雑ランプ</h2>

      <div className={cn("lamp", `lamp--${lamp.color}`)}>
        <LampInner lamp={lamp} color={lamp.color} />
      </div>

      {props.place.lampRemark && (
        <div className={styles.remark}>
          <img src={arrow} />
          <div>
            <span>{props.place.lampRemark}</span>
          </div>
        </div>
      )}
    </div>
  )
}

export default Lamp
